import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选吃瓜视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时更新最新吃瓜视频资源，聚合51吃瓜与91吃瓜等平台高清内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Thumbnail */}
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Play overlay */}
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                    <i className="ri-play-fill text-primary-600 group-hover:text-white text-2xl ml-0.5"></i>
                  </span>
                </div>
                {/* Duration badge */}
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-white text-xs">
                  {item.duration}
                </span>
              </div>

              {/* Info */}
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.views} 次观看</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}